import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
import { EExternalSource } from './external-sources';
import { EFollowupOperation } from './followup';
import { EModel } from './model';
export let EReminderType;
(function (EReminderType) {
  EReminderType["Appointment"] = "appointment";
  EReminderType["Feedback"] = "feedback";
  EReminderType["Referral"] = "referral";
  EReminderType["OutboundReferral"] = "outbound-referral";
  EReminderType["Followup"] = "followup";
  EReminderType["PatientForm"] = "patient-form";
  EReminderType["Recall"] = "recall";
  EReminderType["Telehealth"] = "telehealth";
  EReminderType["WaitingRoom"] = "waiting-room";
})(EReminderType || (EReminderType = {}));
export let EReminderStatus;
(function (EReminderStatus) {
  EReminderStatus["Scheduled"] = "scheduled";
  EReminderStatus["Pending"] = "pending";
  EReminderStatus["Queued"] = "queued";
  EReminderStatus["Sent"] = "sent";
  EReminderStatus["Confirmed"] = "confirmed";
  EReminderStatus["EmailOpened"] = "emailOpened";
  EReminderStatus["Skipped"] = "skipped";
  EReminderStatus["Failed"] = "failed";
  EReminderStatus["Delivered"] = "delivered";
  EReminderStatus["Blocked"] = "blocked";
})(EReminderStatus || (EReminderStatus = {}));
export let EReminderExternalSource;
(function (EReminderExternalSource) {
  EReminderExternalSource["Mandrill"] = "mandrill";
  EReminderExternalSource["Twilio"] = "twilio";
  EReminderExternalSource["Nexmo"] = "nexmo";
  EReminderExternalSource["Sendgrid"] = "sendgrid";
  EReminderExternalSource["Plivo"] = "plivo";
  EReminderExternalSource["AWSSES"] = "awsses";
})(EReminderExternalSource || (EReminderExternalSource = {}));
export const fieldsReminder = _extends({}, fieldsIBaseModel, {
  appointment: {
    type: 'ID',
    ref: EModel.Appointment
  },
  contact: {
    type: 'Text',
    array: true
  },
  externalId: {
    type: 'Option',
    values: EExternalSource
  },
  facility: {
    type: 'ID',
    ref: EModel.Facility
  },
  followup: {
    type: 'ID',
    ref: EModel.Followup
  },
  followupOperation: {
    type: 'Option',
    values: EFollowupOperation
  },
  forcedTime: {
    type: 'Boolean'
  },
  message: {
    type: 'Unknown'
  },
  messageTemplate: {
    type: 'Text'
  },
  originalRepliedMessage: {
    type: 'Text'
  },
  partialStatus: {
    type: 'Object',
    array: true
  },
  patient: {
    type: 'ID',
    ref: EModel.Patient
  },
  patientForm: {
    type: 'ID',
    ref: EModel.PatientForm
  },
  provider: {
    type: 'ID',
    ref: EModel.Provider
  },
  recall: {
    type: 'ID',
    ref: EModel.Recall
  },
  referral: {
    type: 'ID',
    ref: EModel.Referral
  },
  replied: {
    type: 'Number'
  },
  repliedMessage: {
    type: 'Text'
  },
  repliedTime: {
    type: 'Date'
  },
  sendAt: {
    type: 'Date'
  },
  sentAt: {
    type: 'Date'
  },
  status: {
    type: 'Option',
    values: EReminderStatus
  },
  statusReason: {
    type: 'Text'
  },
  statusUpdatedAt: {
    type: 'Date'
  },
  telehealth: {
    type: 'ID',
    ref: EModel.Telehealth
  },
  type: {
    type: 'Option',
    values: EReminderType
  }
});